import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

class Dropdown extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    label: 'common.actions',
    onClick: (e) => e.preventDefault(),
  };

  render = () => (
    <div className="dropdown-button">
      <a className="btn ml-1 btn-secondary" href={'#dropdown'} onClick={this.props.onClick}>
        <span className="mr-1">{this.props.t(this.props.label)}</span>
        <i className="fa fa-angle-down" />
      </a>
      <div className="dropdown-menu">{this.props.children}</div>
    </div>
  );
}

export default translate()(Dropdown);



// WEBPACK FOOTER //
// src/modules/common/components/Dropdown.js